module.exports = __webpack_public_path__ + "img/1549633819.e4314465.jpg";